import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface PassportModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function PassportModal({ open, onClose, setOpen }: PassportModalProps) {
  return (
    <Modal
      className="modal passport_modal"
      id="passportModal"
      aria-labelledby="passport-modal-title"
      aria-describedby="passport-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Passport / ID</h2>
            <div className="btn_flex">
              <Button className="btn btn_highlight">
                <img src="/static/images/import_icon.svg" alt="Icon" /> QR code
              </Button>
              <Button className="btn btn_highlight">
                <img src="/static/images/import_icon.svg" alt="Icon" /> Finger Print
              </Button>
            </div>
          </div>
          <figure className="passport_img">
            <img src="/static/images/passport_attachment.jpg" alt="Passport" />
          </figure>
          <div className="footer_btn_flex">
            <Button className="btn btn_secondary" onClick={() => setOpen(false)}>
              Okay
            </Button>
            <Button className="btn btn_highlight">Download</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
